import React from 'react';
import { translate } from '../../Services/translation';
import QuickSearchLinks from './QuickSearchLinks';

const NoResults = ({ dataMenus, links, hasSearched }) => {
  return (
    <>
      <div className="quick-search-result__no-results">
        {hasSearched && (
          <div className="quick-search-result__no-results__content">
            <h5>{translate('quick-search-results.no-hits-title')}</h5>
            {translate('quick-search-results.no-hits')}
          </div>
        )}
        {links.length > 0 && (
          <div className="quick-search-links">
            <QuickSearchLinks links={links} />
          </div>
        )}
      </div>
    </>
  );
};

export default NoResults;
